import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bf8e1ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center md:tw-justify-start nuevo-turno" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nueva Cita", -1))
const _hoisted_3 = { class: "tw-w-full tw-flex tw-flex-col tw-space-y-4" }
const _hoisted_4 = { class: "text-left flex flex-col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "videoConsulta",
  class: "ml-2 cursor-pointer"
}, "Video consulta", -1))
const _hoisted_6 = { class: "text-left flex flex-col" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "coberturaPrivada",
  class: "ml-2 cursor-pointer"
}, "Cita Privada", -1))
const _hoisted_8 = { class: "tw-w-full tw-flex tw-justify-end tw-items-center" }
const _hoisted_9 = { class: "tw-flex! tw-justify-between! tw-items-center! tw-pt-2! tw-text-center" }
const _hoisted_10 = { class: "p-field-checkbox" }
const _hoisted_11 = { class: "p-field-checkbox" }
const _hoisted_12 = { class: "p-field-checkbox" }
const _hoisted_13 = { class: "p-field-checkbox" }
const _hoisted_14 = { class: "p-field-checkbox" }
const _hoisted_15 = { class: "p-field-checkbox" }
const _hoisted_16 = { class: "p-field-checkbox" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" No se encontraron datos. ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "tw-mt-2" }, null, -1))
const _hoisted_19 = { class: "tw-pt-2" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Confirmar")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-flex tw-items-center tw-justify-center tw-pt-8" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "tw-w-20 tw-rounded-full",
    style: {"aspect-ratio":"1/1","border":"2px solid lch(from var(--primary-color) l c h)","border-left-color":"lightgray","animation":"spin 1s ease-in-out infinite"}
  })
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "tw-mt-2" }, null, -1))
const _hoisted_23 = { class: "tw-pt-2" }
const _hoisted_24 = { class: "tw-w-full tw-flex tw-items-center tw-justify-center tw-pt-8" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "tw-mt-2" }, null, -1))
const _hoisted_26 = { class: "tw-pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, { position: "bottom-right" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Card, { class: "animate tw-w-96 md:tw-ml-3 tw-p-4" }, {
        title: _withCtx(() => [
          _hoisted_2
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Dropdown, {
              onChange: _ctx.handleChangeEspecialidad,
              class: "tw-w-full",
              showClear: "",
              modelValue: _ctx.especialidad,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.especialidad) = $event)),
              options: _ctx.especialidadesList,
              optionLabel: "descripcion",
              placeholder: "Especialidad",
              filter: !_ctx.isIOS,
              filterPlaceholder: "Buscar.."
            }, null, 8, ["onChange", "modelValue", "options", "filter"]),
            _createVNode(_component_Dropdown, {
              class: "tw-w-full",
              modelValue: _ctx.medico,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.medico) = $event)),
              options: _ctx.medicosList,
              optionLabel: "nombre",
              placeholder: "Profesional",
              filter: !_ctx.isIOS,
              filterPlaceholder: "Buscar.."
            }, null, 8, ["modelValue", "options", "filter"]),
            _createVNode(_component_Dropdown, {
              class: "tw-w-full",
              modelValue: _ctx.sucursal,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sucursal) = $event)),
              options: _ctx.sucursalesList,
              optionLabel: "direccion",
              placeholder: "Sucursal",
              filter: !_ctx.isIOS,
              filterPlaceholder: "Buscar.."
            }, null, 8, ["modelValue", "options", "filter"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Checkbox, {
                id: "videoConsulta",
                modelValue: _ctx.filtrarVideoConsulta,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filtrarVideoConsulta) = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_5
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Checkbox, {
                id: "coberturaPrivada",
                modelValue: _ctx.isCoberturaPrivada,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isCoberturaPrivada) = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Button, {
                class: "p-button-link",
                label: "Avanzada",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.avanzadosToggle = !_ctx.avanzadosToggle)),
                icon: `pi ${_ctx.avanzadosToggle ? 'pi-minus' : 'pi-plus'}`,
                iconPos: "right"
              }, null, 8, ["icon"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["tw-w-full tw-flex tw-flex-col tw-space-y-4 tw-transition-all", {"tw-h-0 tw-overflow-hidden":!_ctx.avanzadosToggle, "tw-h-36 tw-overflow-hidden ":_ctx.avanzadosToggle}])
            }, [
              _createVNode(_component_Calendar, {
                class: "tw-w-full",
                modelValue: _ctx.fecha,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fecha) = $event)),
                selectionMode: "range",
                yearNavigator: true,
                yearRange: "2000:2030",
                monthNavigator: true
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Checkbox, {
                    class: "tw-hidden!",
                    id: "lunes",
                    value: "Lunes",
                    modelValue: _ctx.DiasSeleccionados,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.DiasSeleccionados) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    class: _normalizeClass([{active:_ctx.DiasSeleccionados.some(dia => dia === "Lunes")}, "boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none"]),
                    for: "lunes"
                  }, "Lu", 2)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_Checkbox, {
                    class: "tw-hidden!",
                    id: "martes",
                    value: "Martes",
                    modelValue: _ctx.DiasSeleccionados,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.DiasSeleccionados) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    class: _normalizeClass([{active:_ctx.DiasSeleccionados.some(dia => dia === "Martes")}, "boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none"]),
                    for: "martes"
                  }, "Ma", 2)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Checkbox, {
                    class: "tw-hidden!",
                    id: "miercoles",
                    value: "Miércoles",
                    modelValue: _ctx.DiasSeleccionados,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.DiasSeleccionados) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    class: _normalizeClass([{active:_ctx.DiasSeleccionados.some(dia => dia === "Miércoles")}, "boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none"]),
                    for: "miercoles"
                  }, "Mi", 2)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Checkbox, {
                    class: "tw-hidden!",
                    id: "jueves",
                    value: "Jueves",
                    modelValue: _ctx.DiasSeleccionados,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.DiasSeleccionados) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    class: _normalizeClass([{active:_ctx.DiasSeleccionados.some(dia => dia === "Jueves")}, "boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none"]),
                    for: "jueves"
                  }, "Ju", 2)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Checkbox, {
                    class: "tw-hidden!",
                    id: "viernes",
                    value: "Viernes",
                    modelValue: _ctx.DiasSeleccionados,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.DiasSeleccionados) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    class: _normalizeClass([{active:_ctx.DiasSeleccionados.some(dia => dia === "Viernes")}, "boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none"]),
                    for: "viernes"
                  }, "Vi", 2)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_Checkbox, {
                    class: "tw-hidden!",
                    id: "sabado",
                    value: "Sábado",
                    modelValue: _ctx.DiasSeleccionados,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.DiasSeleccionados) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    class: _normalizeClass([{active:_ctx.DiasSeleccionados.some(dia => dia === "Sábado")}, "boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none"]),
                    for: "sabado"
                  }, "Sa", 2)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Checkbox, {
                    class: "tw-hidden!",
                    id: "domingo",
                    value: "Domingo",
                    modelValue: _ctx.DiasSeleccionados,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.DiasSeleccionados) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    class: _normalizeClass([{active:_ctx.DiasSeleccionados.some(dia => dia === "Domingo")}, "boton-dia tw-py-1! tw-px-2! tw-cursor-pointer tw-select-none"]),
                    for: "domingo"
                  }, "Do", 2)
                ])
              ])
            ], 2),
            _createVNode(_component_Button, {
              loading: _ctx.isLoadSugerencias,
              disabled: !_ctx.especialidad || !_ctx.medico || (!_ctx.coberturaValida && !_ctx.coberturaParticular),
              label: "Consultar Citas Disponibles",
              class: "tw-w-full",
              onClick: _ctx.handleConsultarTurnos
            }, null, 8, ["loading", "disabled", "onClick"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Dialog, {
        appendTo: "self",
        position: "right",
        class: "lg:tw-mr-20!",
        header: "Citas Disponibles",
        style: {width: '50vw',},
        breakpoints: {'960px': '75vw', '640px': '100vw', '425px' : '100vw'},
        visible: _ctx.consultarTurnosForm,
        "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.consultarTurnosForm) = $event))
      }, {
        footer: _withCtx(() => [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_Button, {
              disabled: !_ctx.turnoSeleccionado,
              type: "button",
              class: _normalizeClass(["p-button-primary", _ctx.turnoSeleccionado ? "" : "p-button-outlined"]),
              loading: _ctx.isLoadTurnosCreate,
              onClick: _ctx.handleConfirmarSeleccion
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }, 8, ["disabled", "class", "loading", "onClick"]),
            _createVNode(_component_Button, {
              label: "Salir",
              class: "p-button-primary p-button-outlined tw-px-8",
              onClick: _ctx.handleCancelarSeleccion
            }, null, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DataTable, {
            class: "table-turnos-disponibles",
            value: _ctx.turnosDisponiblesList,
            selectionMode: "single",
            selection: _ctx.turnoSeleccionado,
            "onUpdate:selection": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.turnoSeleccionado) = $event)),
            responsiveLayout: "stack",
            scrollHeight: "50vh"
          }, {
            empty: _withCtx(() => [
              _hoisted_17
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "fecha",
                class: "tw-w-32",
                header: "Fecha"
              }),
              _createVNode(_component_Column, {
                field: "hora",
                class: "tw-w-12",
                header: "Hora"
              }),
              _createVNode(_component_Column, {
                field: "profesional",
                header: "Profesional"
              }),
              _createVNode(_component_Column, {
                field: "especialidad",
                header: "Especialidad"
              }),
              _createVNode(_component_Column, {
                field: "sucursal",
                header: "Sucursal"
              })
            ]),
            _: 1
          }, 8, ["value", "selection"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        modal: true,
        closable: false,
        appendTo: "self",
        header: "Esperando Pago",
        visible: _ctx.isPagoVisible,
        "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.isPagoVisible) = $event))
      }, {
        footer: _withCtx(() => [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_Button, {
              text: true,
              label: "Cancelar",
              class: "p-button-text tw-px-8",
              onClick: _ctx.handleCancelarPago
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              link: "",
              label: "Reintentar Pago",
              type: "button",
              class: "p-button-primary",
              onClick: _ctx.handleRetryPago,
              icon: "pi pi-external-link",
              iconPos: "right"
            }, null, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_21
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        closable: false,
        modal: true,
        appendTo: "self",
        header: "Cita Pendiente",
        visible: _ctx.showConfirmTurnoPendiente,
        "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showConfirmTurnoPendiente) = $event))
      }, {
        footer: _withCtx(() => [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_Button, {
              text: true,
              label: "Cancelar",
              class: "p-button-text tw-px-8",
              onClick: _ctx.handleCancelarPago
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              link: "",
              label: "Abonar",
              type: "button",
              class: "p-button-primary",
              onClick: _ctx.handleConfirmTemporal,
              icon: "pi pi-external-link",
              iconPos: "right"
            }, null, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", null, _toDisplayString(_ctx.textTurnoPendiente), 1)
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}